<template>
  <div class="table-wrapper" unselectable="on">
    <LoaderWait v-show="loading"/>
    <table class="main-table">
      <tr>
        <td class="td-logo" width="30%"><img src="/imgs/logo_impay.png"></td>
        <td colspan="2"></td>
      </tr>
      <tr>
        <td colspan="3" align="center">
          <div class="input-head-text">Введите код из SMS</div>
        </td>
      </tr>
      <tr>
        <td colspan="3" align="center">
          <div class="fon-input">
            <input type="text" readonly class="input-field" v-model="passwordMask">
            <img @click="clickBsKey" class="bnt-key-bs" src="/imgs/btn_bs_1.png">
          </div>
        </td>
      </tr>
      <tr>
        <td class="td-row" width="30%">
          <div style="padding: 10px" v-show="user !== null && user.status == 1">
            <img @click="resetPassword" src="/imgs/btn_resetpw_1.png">
          </div>
        </td>
        <td class="td-row" width="40%" align="center">
          <KeyboardDigital :on-click="onClickKey"></KeyboardDigital>
        </td>
        <td width="30%">
        </td>
      </tr>
      <tr>
        <td class="td-nav" width="30%">
          <img @click="backClick" src="/imgs/back_1.png">
        </td>
        <td class="td-nav" width="40%" align="center">
          <img @click="exitClick" src="/imgs/menu_impay_1.png">
        </td>
        <td class="td-nav" width="30%" align="right">
          <img @click="fwdClick" src="/imgs/fwd_1.png">
        </td>
      </tr>
    </table>
    <MessageBox :message="errorMessage" v-show="showMessage" :on-close="messageClose"></MessageBox>
  </div>
</template>

<style>

</style>
<script>
import KeyboardDigital from "@/components/KeyboardDigital.vue";
import LoaderWait from "@/components/LoaderWait.vue";
import MessageBox from "@/components/MessageBox.vue";
import {formatMask} from "@/utils/format_mask";

export default {
  name: 'LoginPage',
  components: {MessageBox, LoaderWait, KeyboardDigital },
  data () {
    return {
      loading: false,
      timer: null,
      password: '',
      passwordMask: '',
      showMessage: false,
      errorMessage: '',
    }
  },
  computed: {
    user() {
      const data = this.$store.getters.GET_USER_PROFILE
      if (data !== null) {
        return data
      } else {
        return null
      }
    },
  },
  mounted() {
    this.updateTimer()
  },
  methods: {
    updateTimer() {
      this.stopTimer()
      this.timer = setTimeout(() => this.exitClick(), 60000)
    },
    stopTimer() {
      if (this.timer !== null) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    onClickKey(key) {
      this.updateTimer()
      if (this.password.length < 4) {
        this.password = this.password + key
        this.updatePasswordMask()
      }
    },
    clickBsKey() {
      this.updateTimer()
      if (this.password.length > 0) {
        this.password = this.password.substring(0, this.password.length - 1)
        this.updatePasswordMask()
      }
    },
    updatePasswordMask() {
      let strr = ''
      for (let i = 0; i < this.password.length; i++) {
        strr += '●';//'✹';
      }
      this.passwordMask = formatMask(strr, '          # # # #')
    },
    fwdClick() {
      if (this.loading) {
        return false;
      }
      if (!this.password.length) {
        return false;
      }

      this.stopTimer()
      this.loading = true

      if (this.user.status == 0) {
        this.$store.dispatch('AUTH_CHECK_CODE', {
          phone: this.user.phone,
          code: this.password,
        }).then((res) => {
          this.loading = false
          if (res.status == 1) {
            this.passwordCheck();
          } else {
            this.updateTimer()
            this.messageShow('Ошибка проверки кода, попробуйте ещё раз')
            this.password = ''
          }
        }).catch((e) => {
          this.loading = false
          if (e.response !== undefined && e.response.status === 401) {
            this.$store.dispatch('AUTH_LOGOUT')
          }
        })
      } else {
        this.passwordCheck();
      }
    },
    passwordCheck() {
      this.$store.dispatch('AUTH_PASSWORD_REQUEST', {
        phone: this.user.phone,
        password: this.password,
      }).then((res) => {
        this.loading = false
        if (res.status == 1) {
          if (this.user['identification_status'] == 0) {
            this.$router.push('identify')
          } else {
            this.$router.push('main')
          }
        } else {
          this.updateTimer()
          this.messageShow('Ошибка проверки пароля, попробуйте ещё раз')
          this.password = ''
          this.updatePasswordMask()
        }
      }).catch((e) => {
        this.loading = false
        if (e.response !== undefined && e.response.status === 401) {
          this.$store.dispatch('AUTH_LOGOUT')
        }
      })
    },
    backClick() {
      this.stopTimer()
      this.$router.go(-1)
    },
    exitClick() {
      this.stopTimer()
      this.$store.dispatch('AUTH_LOGOUT')
    },
    resetPassword() {
      this.updateTimer()
      this.$store.dispatch('AUTH_RESET_PASSWORD', {
        phone: this.user.phone
      }).then((res) => {
        this.loading = false
        if (res.status == 1) {
          this.messageShow('Новый пароль отправлен в СМС')
        } else {
          this.messageShow('Ошибка запроса, попробуйте повторить позднее')
        }
      }).catch((e) => {
        this.loading = false
        if (e.response !== undefined && e.response.status === 401) {
          this.$store.dispatch('AUTH_LOGOUT')
        }
      })
    },
    messageShow(message) {
      this.showMessage = true;
      this.errorMessage = message;
      // Возвращаем Promise, который будет разрешён в messageClose
      return new Promise((resolve) => {
        this.messagePromiseResolver = resolve;
      });
    },
    messageClose() {
      this.showMessage = false;
      this.errorMessage = '';
      // Разрешаем Promise, если он существует
      if (this.messagePromiseResolver) {
        this.messagePromiseResolver();
        this.messagePromiseResolver = null;
      }
    },
  }
}
</script>
